import(/* webpackMode: "eager" */ "/builds/brand/svc/ishop/ishop-frontend/src/modules/forgot-password/forgot-password.component.tsx")